module.exports = __webpack_public_path__ + "media/fish.e04f1147.wav";